function trimTrailingSlashes(value) {
  const normalized = String(value || "").trim().replace(/\/+$/, "");
  return normalized || "/";
}

function getWindowOrigin() {
  if (typeof window !== "undefined" && window.location) {
    return window.location.origin;
  }
  return "";
}

export const API_BASE_URL = trimTrailingSlashes(
  process.env.VUE_APP_BASE_API || "/api"
);

export const ASSET_BASE_URL = trimTrailingSlashes(
  process.env.VUE_APP_ASSET_BASE_URL || getWindowOrigin()
);

export function resolveAssetUrl(path) {
  if (path === null || path === undefined || path === "") {
    return "";
  }

  const value = String(path).trim();
  if (/^(?:[a-z]+:)?\/\//i.test(value) || /^(?:data|blob):/i.test(value)) {
    return value;
  }

  return `${ASSET_BASE_URL === "/" ? "" : ASSET_BASE_URL}/${value.replace(/^\/+/, "")}`;
}
